<template>
	<el-dropdown size="small" class="d2-mr">
		<span class="btn-text">{{info.name ? `你好 ${info.name}` : '未登录'}}</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item @click.native="changePassword">
				<d2-icon name="key" class="d2-mr-5" />
				修改密码
			</el-dropdown-item>
			<el-dropdown-item @click.native="logOff">
				<d2-icon name="power-off" class="d2-mr-5" />
				注销
			</el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	import request from '@/plugin/axios'

	export default {
		computed: {
			...mapState('d2admin/user', [
				'info'
			])
		},
		methods: {
			...mapActions('d2admin/account', [
				'logout'
			]),
			/**
			 * @description 登出
			 */
			logOff() {
				this.logout({
					confirm: true
				})
			},
			//修改我的密码
			changePassword() {
				this.$prompt('请输入新密码：', '修改我的密码', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^[A-Za-z0-9]{6,}$/,
					inputErrorMessage: '6位以上的英文或数字',
					closeOnClickModal: false,
				}).then(({
					value
				}) => {
					request.get('/change_password', {
						params: {
							new_password: this.$md5(value)
						}
					}).then(res => {
						this.$message.success(res.msg)
					})
				}).catch(() => {})
			},
		}
	}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
